import React from 'react'
import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'

import { useIsWidthDown } from '../hooks'

import { Icon } from './icon.tsx'

// https://www.figma.com/file/U4T9fkZqC0VQKJqGeLjIDi/%D0%91%D0%B8%D0%B1%D0%BB%D0%B8%D0%BE%D1%82%D0%B5%D0%BA%D0%B0-%D0%98%D0%9A?type=design&node-id=6570-15162&mode=design&t=c3QA4VinOcgdowav-4
export interface DialogProps {
  title: string
  open: boolean
  maxWidth?: MuiDialogProps['maxWidth']
  onClose(): void
  content: React.ReactNode
  actions?: React.ReactNode
}

export const Dialog = ({
  content,
  actions,
  title,
  open,
  onClose,
  maxWidth = 'md',
}: DialogProps): React.ReactElement => {
  const fullScreen = useIsWidthDown('md')

  return (
    <MuiDialog
      open={open}
      scroll="body"
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      disablePortal={false}
      fullScreen={fullScreen}
      PaperProps={{
        sx: ({ breakpoints }) => ({
          borderRadius: { md: 4 },
          backgroundColor: 'background.default',
          '&.MuiDialog-paperFullScreen': {
            [breakpoints.down('md')]: {
              px: 4,
              pt: 9,
              pb: 4,
            },
            [breakpoints.down('sm')]: {
              px: 2,
              pt: 5,
              pb: 3,
            },
          },
          pt: {
            xs: 5,
            md: 7,
          },
          px: {
            xs: 2,
            md: 7,
          },
          pb: {
            xs: 3,
            md: 7,
          },
        }),
      }}
    >
      <DialogTitle sx={({ typography }) => ({ ...typography.h2, p: 0, pb: 3 })}>{title}</DialogTitle>
      <IconButton
        size="large"
        onClick={onClose}
        color="secondary"
        sx={(theme) => ({
          position: 'absolute',
          top: theme.spacing(2.5),
          right: theme.spacing(2.5),
          color: theme.palette.text.primary,
          borderRadius: 20,
          backgroundColor: theme.palette.background.paper,
          transition: theme.transitions.create(['color', 'background-color']),
          '&:hover': {
            color: theme.palette.text.tertiary,
          },
        })}
      >
        <Icon name="Close" size="lg" />
      </IconButton>
      <DialogContent sx={{ px: 0, overflowY: 'initial' }}>{content}</DialogContent>
      {actions && <DialogActions sx={{ p: 0, pt: { sm: 4, lg: 6 } }}>{actions}</DialogActions>}
    </MuiDialog>
  )
}
